module.exports = __webpack_public_path__ + "bin/0267308d2af78e1774505786b02d54c9.png";